<template>
  <h4>Directory!</h4>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
